import React from "react";
import { useFela } from "react-fela";

import { Grid } from "@/components/Grid";
import { useTheme } from "@/hooks/useTheme";
import { Heading } from "@/components/Heading";
import { IHowItWorksStepsSection } from "./types";
import { StepWrapper } from "./StepWrapper";

type IProps = IHowItWorksStepsSection & JSX.IntrinsicElements["div"];

export const HowItWorksStepsSection: React.FC<IProps> = ({
  title,
  subtitle,
  sourceSteps,
  targetSteps,
  ...rest
}) => {
  const { css } = useFela();
  const { bp } = useTheme();

  return (
    <Grid
      customStyle={{ flexDirection: "column", position: "relative" }}
      {...rest}
      id="HowItWorksStepsSection"
    >
      <div className={css({ textAlign: "center" })}>
        <Heading as="h2">{title}</Heading>
        <Heading as="h4" customStyle={{ fontWeight: 400 }}>
          {subtitle}
        </Heading>
      </div>

      <div
        className={css({
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          margin: "64px 0 0",
          border: "1px solid #E5E7EB",
          borderRadius: 6,
          [bp.FROM_TABLET]: {
            flexWrap: "nowrap",
          },
        })}
      >
        <div
          className={css({
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
            [bp.FROM_TABLET]: {
              flexDirection: "row",
              alignItems: "flex-start",
            },
          })}
        >
          <StepWrapper stepsData={sourceSteps} />
          <span
            className={css({
              width: "80%",
              alignSelf: "center",
              borderTop: "1px solid #D1D5DB",
              [bp.FROM_TABLET]: {
                height: "70%",
                width: 0,
                borderLeft: "1px solid #D1D5DB",
                borderTop: "none",
              },
            })}
          />
          <StepWrapper stepsData={targetSteps} />
        </div>
      </div>
    </Grid>
  );
};
